import { render, staticRenderFns } from "./VerifiedInput.vue?vue&type=template&id=48d7cf70&scoped=true"
import script from "./VerifiedInput.vue?vue&type=script&lang=js"
export * from "./VerifiedInput.vue?vue&type=script&lang=js"
import style0 from "./VerifiedInput.vue?vue&type=style&index=0&id=48d7cf70&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48d7cf70",
  null
  
)

export default component.exports